type Key = string
type Value = string

type Params = [Key, Value][]

export function addParamsToUrl(href: string, params: Params) {
  if (params.length > 0 && (href.includes(window.location.origin) || href.startsWith('/'))) {
    const url = new URL(href, window.location.origin)

    params.forEach(([key, value]) => {
      url.searchParams.set(key, value)
    })

    if (href.startsWith('/')) {
      return `${url.pathname}${url.search}${url.hash}`
    }

    return url.href
  }

  return href
}
